import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { FlagWrapper } from './FlagWrapper';
var withFlagWrapper = FlagContent => {
  var Flag = FlagWrapper(FlagContent);
  Flag.displayName = FlagContent.displayName;
  return withProvisionalOverrideFromContext(Flag);
};
export default withFlagWrapper;
//# sourceMappingURL=index.js.map